module.exports = __webpack_public_path__ + "static/media/mainChartDescr2.8a5cd9ef.png";